import { FieldType } from '@wix/wix-data-schema-types'
import { SECTION_ROLE } from '@wix/wix-data-client-common-standalone'
import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'

const {
  image,
  video,
  color,
  text,
  email,
  number,
  dateTime,
  date,
  address,
  stringArray,
} = FieldType

export default (): DataBindingComponentModel => ({
  componentName: 'Element_Name_Section',
  isConnectGfppEnabled: true,
  supportsDefaultSelectedDataset: true,
  panel: {
    height: 297,
    title: 'Connect_Panel_Title_Section',
    helpId: '85f062c6-cbb0-4336-bec5-637c007e90ca',
  },
  sections: [
    {
      role: SECTION_ROLE,
      bindings: [
        {
          title: 'Connect_Panel_Connect_Section_Background_Label',
          prop: 'background.src',
          supportedFieldTypes: [image, video],
          defaultFieldType: image,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
        },

        {
          title: 'connectSectionPanel.backgroundAltBinding.title',
          prop: 'background.alt',
          supportedFieldTypes: [
            text,
            email,
            number,
            dateTime,
            date,
            address,
            stringArray,
          ],
          defaultFieldType: text,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
        },

        {
          title: 'Connect_Panel_Connect_Section_BackgroundColor',
          prop: 'style.backgroundColor',
          supportedFieldTypes: [color],
          defaultFieldType: color,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
        },
      ],
      manifest: {
        gfpp: {
          desktop: {
            mainAction1: {
              actionId: 'section_live_preview_gfpp_desktop_main_action',
              label: 'Section_Live_Preview_GFPP_Desktop_Main_Action',
            },
          },
        },
      },
    },
  ],
  compactErrorPanel: true,
})
